export default "__VITE_ASSET__638924f4__"